var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trend_down_right",
    "data-name": "trend down right"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.8 1.25h-19.6a4.952 4.952 0 0 0 -4.95 4.95v19.6a4.952 4.952 0 0 0 4.95 4.95h19.6a4.952 4.952 0 0 0 4.95-4.95v-19.6a4.952 4.952 0 0 0 -4.95-4.95zm-3.206 22.373-5.317-1.217.335-1.462 2.835.649-3.047-4.843h-6.747l-2.368-7.525 1.43-.45 2.038 6.475h6.474l3.432 5.45.606-2.97 1.47.3z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecline);
export default __webpack_public_path__ + "static/media/decline.04e6a12da9c448663604b6b4131b2f01.svg";
export { ForwardRef as ReactComponent };